export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10895.0629e502.jpg";